import KeyboardKeyIcon from '@/components/ui/keyboard-key-icon';
import { PDKAttachFileIcon } from '@/components/ui/pdk-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { HOTKEYS } from '@/lib/hotkeys';
import { cn } from '@/lib/utils';
import type { Deal } from '@/models/registry';
import { useCallback, useId, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useUploadFilesToDealMutation } from './deal-file-drag-and-drop';

const DealUploadButton = ({ dealId }: { dealId: Deal['id'] }) => {
  const { uploadFilesMutation } = useUploadFilesToDealMutation(dealId);
  const inputId = useId();
  const inputRef = useRef<HTMLInputElement>(null);

  // Handle file input change
  const handleFileInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files.length > 0) {
        uploadFilesMutation.mutate(e.target.files);
      }
    },
    [uploadFilesMutation],
  );

  useHotkeys(HOTKEYS.DEAL_UPLOAD_FILE, () => {
    inputRef.current?.click();
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex flex-col items-center justify-center">
          <p className="text-xs  text-gray-600">
            <label htmlFor={inputId} className="hover:underline cursor-pointer">
              <PDKAttachFileIcon className={cn('cursor-pointer', {})} />
            </label>
          </p>
          <input
            ref={inputRef}
            id={inputId}
            type="file"
            className="hidden"
            multiple
            onChange={handleFileInputChange}
          />
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <div className="flex flex-row gap-2">
          <p className="text-xs">Attach an image or file to this deal</p>
          <KeyboardKeyIcon className="w-4 h-4">
            {HOTKEYS.DEAL_UPLOAD_FILE}
          </KeyboardKeyIcon>
        </div>

        <p className="text-xs text-gray-500">
          Supported file type: PNG, JPEG, PDF, CSV, TXT
        </p>
      </TooltipContent>
    </Tooltip>
  );
};

export default DealUploadButton;
